
import SEO from '@/components/SEO';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import PartnerLogosSection from '@/components/shared/PartnerLogosSection';
import PartnerTypesSection from '@/components/partners/PartnerTypesSection';
import IntegrationBenefitsSection from '@/components/partners/IntegrationBenefitsSection';
import PartnershipLevelsSection from '@/components/partners/PartnershipLevelsSection';

const Partners = () => {
  return (
    <>
      <SEO 
        title="Partners - Join the SeniorThrive Ecosystem"
        description="Partner with SeniorThrive to enhance your senior care services. Integration opportunities for healthcare providers, home care agencies, senior living communities, and technology partners."
        keywords="senior care partnerships, healthcare integration, home care technology, senior living partners, aging in place solutions"
      />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-cover bg-center bg-no-repeat text-white overflow-hidden" style={{ backgroundImage: "url('/lovable-uploads/aa928395-b99a-40c0-9526-2b3b9de5bf89.png')" }}>
        {/* Overlay */}
        <div className="absolute inset-0 bg-primary/80"></div>
        <div className="relative z-10 container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
              Scale Your Impact Across the Senior Care Ecosystem
            </h1>
            <p className="text-xl md:text-2xl mb-8 opacity-90">
              Integration, co-branding, and data partnerships for tech, healthcare, and service ecosystems.
            </p>
            <p className="text-lg opacity-80 max-w-2xl mx-auto">
              Integrate your solutions into the Home OS ecosystem to reach families and seniors where they live.
            </p>
          </div>
        </div>
      </section>

      <PartnerTypesSection />
      
      <IntegrationBenefitsSection />

      <PartnershipLevelsSection />

      {/* Current Partners */}
      <PartnerLogosSection 
        title="Current Technology Partners"
        description="SeniorThrive integrates with services families already know and trust"
        className="py-16"
      />

      {/* CTA Section */}
      <section className="relative py-20 bg-cover bg-center bg-no-repeat text-white overflow-hidden" style={{ backgroundImage: "url('/lovable-uploads/be9a4c34-1f14-4886-9fd5-4358a6e779ac.png')" }}>
        {/* Overlay */}
        <div className="absolute inset-0 bg-primary/80"></div>
        <div className="relative z-10 container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6">Let's Build What Comes Next</h2>
            <p className="text-xl mb-8 opacity-90">
              Talk with our team about integrations, partnerships, and strategic collaboration.
            </p>
            <div className="flex justify-center">
              <Button asChild size="lg" variant="glass">
                <Link to="/contact">Inquire About Partnership</Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Partners;
